<p-breadcrumb
  [model]="[
    { label: 'Pedidos', routerLink: ['/orders'] },
    { label: 'Detalhes do Pedido' },
  ]"
  [home]="{ label: '', routerLink: ['/'] }"
/>

@if (showTabView()) {
  <div class="relative">
    <app-order-details-tab-view
      [order]="order()"
      [eligibilityAssessment]="eligibilityAssessment()"
      [orderNumber]="orderNumber"
      [statusText]="statusText"
      (reloadOrder)="reloadOrder()"
      (setLoading)="loading.set($event)"
    />
    @if (loading()) {
      <div
        class="absolute inset-0 z-10 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
      >
        <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
      </div>
    }
  </div>
} @else {
  <div class="relative">
    @if (order()) {
      <div class="mt-5 relative">
        <div class="card flex flex-wrap items-center justify-between gap-y-2">
          <div class="flex items-center gap-4">
            <p-button
              severity="secondary"
              routerLink="/orders"
              rounded
              class="btn-secondary-outline"
              icon="ph ph-arrow-left"
              title="Voltar para a lista de pedidos"
            ></p-button>
            <div>
              <div class="text-xl">
                <span class="font-bold"> Pedido </span>
                #{{ orderNumber }}
              </div>
              <p>Siga as instruções para realizar a análise corretamente</p>
            </div>
          </div>

          <div
            class="flex flex-wrap items-center justify-end gap-x-6 gap-y-2 ml-auto"
          >
            <div class="flex items-center gap-2 whitespace-nowrap">
              <span class="text-gray-500"> Situação: </span>
              <app-tag-status
                [status]="statusTag"
                [text]="statusText"
              ></app-tag-status>
            </div>
            @if (!isReadOnly()) {
              <div class="flex items-center gap-2 whitespace-nowrap">
                @if (canCancel()) {
                  <p-button
                    type="button"
                    label="Cancelar"
                    icon="ph ph-x-circle"
                    severity="danger"
                    [outlined]="true"
                    rounded
                    (click)="openCancelDialog()"
                  ></p-button>
                }
                <p-button
                  type="button"
                  label="Continuar"
                  rounded
                  (click)="nextStep()"
                ></p-button>
              </div>
            }
          </div>
        </div>
      </div>

      <hr class="m-0!" />
      <div class="wizard-container bg-white p-5">
        <div
          class="progress flex-wrap"
          role="progressbar"
          aria-label="Checkout steps"
        >
          <div
            class="step-item"
            [class.cursor-pointer]="isStepClickable(Step.Documents)"
            [class.cursor-not-allowed]="!isStepClickable(Step.Documents)"
            [class.active]="currentStep() >= Step.Documents"
            (click)="goToStep(Step.Documents)"
            title="Ir para a etapa"
          >
            @if (currentStep() >= Step.Documents) {
              <i class="ph ph-check-circle text-[2.2rem] text-primary"></i>
            } @else {
              <div class="dot">
                <span>1</span>
              </div>
            }
            <div class="step-label">Documentos</div>
          </div>
          <div class="bar" [class.active]="currentStep() >= Step.Payment"></div>

          <div
            class="step-item"
            [class.cursor-pointer]="isStepClickable(Step.Payment)"
            [class.cursor-not-allowed]="!isStepClickable(Step.Payment)"
            [class.active]="currentStep() >= Step.Payment"
            (click)="goToStep(Step.Payment)"
            title="Ir para a etapa"
          >
            @if (currentStep() >= Step.Payment) {
              <i class="ph ph-check-circle text-[2.2rem] text-primary"></i>
            } @else {
              <div class="dot">
                <span>2</span>
              </div>
            }
            <div class="step-label">Taxa de Inscrição</div>
          </div>
          <div class="bar" [class.active]="currentStep() >= Step.Product"></div>

          <div
            class="step-item"
            [class.cursor-pointer]="isStepClickable(Step.Product)"
            [class.cursor-not-allowed]="!isStepClickable(Step.Product)"
            [class.active]="currentStep() >= Step.Product"
            (click)="goToStep(Step.Product)"
            title="Ir para a etapa"
          >
            @if (currentStep() >= Step.Product) {
              <i class="ph ph-check-circle text-[2.2rem] text-primary"></i>
            } @else {
              <div class="dot">
                <span>3</span>
              </div>
            }
            <div class="step-label">Produto</div>
          </div>
          <div
            class="bar"
            [class.active]="currentStep() >= Step.Contract"
          ></div>

          <div
            class="step-item"
            [class.cursor-pointer]="isStepClickable(Step.Contract)"
            [class.cursor-not-allowed]="!isStepClickable(Step.Contract)"
            [class.active]="currentStep() >= Step.Contract"
            (click)="goToStep(Step.Contract)"
            title="Ir para a etapa"
          >
            @if (currentStep() >= Step.Contract) {
              <i class="ph ph-check-circle text-[2.2rem] text-primary"></i>
            } @else {
              <div class="dot">
                <span>4</span>
              </div>
            }
            <div class="step-label">Contrato</div>
          </div>
          <div
            class="bar"
            [class.active]="currentStep() >= Step.Shipment"
          ></div>

          <div
            class="step-item"
            [class.cursor-pointer]="isStepClickable(Step.Shipment)"
            [class.cursor-not-allowed]="!isStepClickable(Step.Shipment)"
            [class.active]="currentStep() >= Step.Shipment"
            (click)="goToStep(Step.Shipment)"
            title="Ir para a etapa"
          >
            @if (currentStep() >= Step.Shipment) {
              <i class="ph ph-check-circle text-[2.2rem] text-primary"></i>
            } @else {
              <div class="dot">
                <span>5</span>
              </div>
            }
            <div class="step-label">Envio</div>
          </div>
        </div>
      </div>

      @if (isReadOnly()) {
        <app-order-cancellation-card [order]="order()" />
      }

      <div class="panels mt-5">
        @switch (currentStep()) {
          @case (Step.Documents) {
            <section class="panel enter w-full" data-step="documents">
              <app-order-details-documents
                [order]="order()"
                [eligibilityAssessment]="eligibilityAssessment()"
                (loadData)="loadData($event)"
              ></app-order-details-documents>
            </section>
          }
          @case (Step.Payment) {
            <section class="panel enter w-full" data-step="payment">
              <app-order-details-payment
                [order]="order()"
                [statusText]="statusText"
              ></app-order-details-payment>
            </section>
          }
          @case (Step.Product) {
            <section class="panel enter w-full" data-step="product">
              <app-order-details-product
                [order]="order()"
                [product]="product"
                (loadData)="loadData($event)"
              ></app-order-details-product>
            </section>
          }
          @case (Step.Contract) {
            <section class="panel enter w-full" data-step="contract">
              <app-order-details-contract
                [order]="order()"
                [statusText]="statusText"
              ></app-order-details-contract>
            </section>
          }
          @case (Step.Shipment) {
            <section class="panel enter w-full" data-step="shipment">
              <app-order-details-shipment
                [order]="order()"
                [customer]="customer"
                [readOnly]="isReadOnly()"
                (loadData)="loadData($event)"
              ></app-order-details-shipment>
            </section>
          }
        }
      </div>
    } @else {
      <div
        class="card space-y-4 flex justify-between items-center mt-5 min-h-40"
      >
        <div class="text-center w-full mb-0">
          <p class="text-center">Pedido não encontrado</p>
        </div>
      </div>
    }
    @if (loading()) {
      <div
        class="absolute inset-0 z-10 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
      >
        <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
      </div>
    }
  </div>
}

<app-order-cancel-dialog
  [(visible)]="cancelDialogVisible"
  [order]="order()"
  (cancelled)="reloadOrder()"
/>

<p-toast />
